'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;
// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _serviceOrderBuy = require('redux/modules/serviceOrderBuy');

var serviceOrderBuyActions = _interopRequireWildcard(_serviceOrderBuy);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderBuy = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    var promises = [];
    // console.log(params);
    if (!serviceOrderBuyActions.isLoaded(getState())) {
      promises.push(dispatch(serviceOrderBuyActions.load(params.serviceProductId)));
    }
    promises.push(dispatch((0, _background.changeHeaderText)('服务订单填写')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.serviceOrderBuy.data,
    submitData: state.serviceOrderBuy.submitData
  };
}, (0, _extends3.default)({}, serviceOrderBuyActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderBuy, _Component);

  function ServiceOrderBuy() {
    (0, _classCallCheck3.default)(this, ServiceOrderBuy);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderBuy).call(this));

    _this.state = {
      initVal: {
        contactPerson: '',
        contactWay: '',
        requires: ''
      }
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceOrderBuy, [{
    key: 'onCloseSendedToShopSuccessModal',
    value: function onCloseSendedToShopSuccessModal() {
      var _props = this.props;
      var clearSendInfo = _props.clearSendInfo;
      var routerPush = _props.routerPush;

      if (clearSendInfo) {
        clearSendInfo().then(routerPush('/personalcenter/personalbuying/productpreselection'));
      }
    }
  }, {
    key: 'onSubmitBtn',
    value: function onSubmitBtn(submitClientData) {
      var _props2 = this.props;
      var submit = _props2.submit;
      var data = _props2.data;
      // const { initVal } = this.state;

      if (submit && data) {
        var serviceOrderBuyInfo = data.serviceOrderBuyInfo;

        if (serviceOrderBuyInfo instanceof Array && serviceOrderBuyInfo.length > 0) {
          submit({
            serviceId: serviceOrderBuyInfo[0].id,
            price: serviceOrderBuyInfo[0].price,
            contactPerson: submitClientData.contactPerson,
            contactWay: submitClientData.contactWay,
            company: submitClientData.company,
            require: submitClientData.requires
          });
        }
      }
    }
  }, {
    key: 'analysisServiceOrderBuyInfo',
    value: function analysisServiceOrderBuyInfo() {
      var data = this.props.data;
      // const { initVal } = this.state;

      var serviceBuyDiv = _react2.default.createElement('div', null);
      if (data) {
        var serviceOrderBuyInfo = data.serviceOrderBuyInfo;
        var serviceOrderBuyInfoError = data.serviceOrderBuyInfoError;
        var serviceBuyClientInfo = data.serviceBuyClientInfo;
        var serviceBuyClientInfoError = data.serviceBuyClientInfoError;

        if (serviceOrderBuyInfoError || serviceBuyClientInfoError) {
          serviceBuyDiv = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.ErrorLabel, { error: serviceOrderBuyInfoError }),
            _react2.default.createElement(_components.ErrorLabel, { error: serviceBuyClientInfoError })
          );
        } else if (serviceOrderBuyInfo instanceof Array && serviceOrderBuyInfo.length > 0 && serviceBuyClientInfo instanceof Array && serviceBuyClientInfo.length > 0) {
          serviceBuyDiv = _react2.default.createElement(_components.ServiceOrderBuyComponent, {
            initialValues: { contactPerson: serviceBuyClientInfo[0].contactPerson, contactWay: serviceBuyClientInfo[0].contactWay, company: serviceBuyClientInfo[0].company, requires: '' },
            onSubmit: this.onSubmitBtn.bind(this), serviceBuyData: serviceOrderBuyInfo,
            serviceClientData: serviceBuyClientInfo });
        }
      }
      return serviceBuyDiv;
    }
  }, {
    key: 'render',
    value: function render() {
      var submitData = this.props.submitData;

      var isSendedToShopModalOpened = false;
      var sendToShopErrorMsg = '';
      if (submitData) {
        if (submitData.isValid) {
          sendToShopErrorMsg = '订单已成功发送给商家';
        } else {
          sendToShopErrorMsg = submitData.message;
        }
        isSendedToShopModalOpened = sendToShopErrorMsg && sendToShopErrorMsg !== '';
      }
      return _react2.default.createElement(
        'div',
        null,
        this.analysisServiceOrderBuyInfo()

        /*
         <SuccessModal isOpened={isSendedToShopModalOpened}
         width="400"
         onSubmit={this.onCloseSendedToShopSuccessModal.bind(this)}
         text={sendToShopErrorMsg}/> */
        ,
        _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isSendedToShopModalOpened,
          loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
          closeModalFunc: this.onCloseSendedToShopSuccessModal.bind(this),
          text: sendToShopErrorMsg })
      );
    }
  }]);
  return ServiceOrderBuy;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  submitData: _react.PropTypes.object,
  load: _react.PropTypes.func,
  isLoaded: _react.PropTypes.func,
  submit: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  clearSendInfo: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ServiceOrderBuy;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceOrderBuy/ServiceOrderBuy.js
 ** module id = 1535
 ** module chunks = 0
 **/